import React from 'react'
import moment from 'moment'
import { Link } from 'react-router-dom'

const notification = ({ notification }) => (
  <div className="border-bottom">
    <div className="container row w-100 ml-0 p-2 d-flex align-items-center justify-items-center bg-white">
      <div className="col-2">
        {!notification.is_read ? (
          <i
            className="fas fa-circle text-danger"
            style={{ fontSize: '0.5rem' }}
          />
        ) : (
          <i className="far fa-circle" style={{ fontSize: '0.5rem' }} />
        )}
      </div>
      <div className="col-10">
        <Link
          to={`/notifications/${notification.id}`}
          style={{ color: 'inherit' }}
        >
          <div
            className={notification.is_read ? 'text-muted' : 'font-weight-bold'}
          >
            {notification.title}
          </div>
          <div>{notification.body}</div>
          <div className="pt-2">
            <small>{moment(notification.createdAt).format('LT')}</small>
          </div>
        </Link>
      </div>
    </div>
  </div>
)

export default notification
